export const REGISTER_ROUTE = '/api/auth/register'
export const AUTHENTICATE_ROUTE = '/api/auth/login'
export const SESSION_ROUTE = '/api/profile'



// WEBPACK FOOTER //
// ./src/store/auth/constants.js